<template>
  <b-container fluid class="bg-white px-0 table-component">
    <b-row class="mb-4" v-if="isDefault">
      <b-col cols="3">
        <h5 class="title f-default mb-0" v-if="title">{{ title }}</h5>
      </b-col>
      <b-col
      :offset="!isRoute ? 3 : 0"
        cols="1"
        class="d-flex justify-content-end align-items-center export"
      >
        <slot name="export" />
      </b-col>
      <b-col cols="5" class="d-flex justify-content-end" >
        <b-input-group size="md" class="search">
          <b-form-input
            v-model="filters.findBy"
            placeholder="Busca"
            @keyup.enter="sendSearch"
            type="text"
            prepend="@"
            
          ></b-form-input>
          <template #append>
            <b-button @click="sendSearch">
              <inline-svg src="/images/icons/search.svg" alt=""  class="img-search"/>
            </b-button>
          </template>
        </b-input-group>
      </b-col>
      <b-col cols="3" class="d-flex justify-content-end" v-if="isRoute">
        <b-button pill :to="route.to" class="btn-black w-100"
          >{{route.name}}</b-button
        >
      </b-col>
    </b-row>
    <b-table
      id="my-table"
      :items="items"
      :fields="fields"
      hover
      :per-page="isDefault ? filters.size : undefined"
      show-empty
      empty-filtered-text=" Nenhum dado encontrado :("
    >
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: field.width }"
          :class="[ field.class, getCustomClass(field)]"
        >
        
      </template>
      <template #row-details()="row">
        {{ row }}
      </template>
      <template #head()="head">
        <span class="text-nowrap user-select-none">{{ head.label }}</span>
      </template>
      <template #empty>
        <p class="f-default text-center">Nenhum dado encontrado :(</p>
      </template>
      <template #cell(id)="data" class="f-default">
        {{ data.item.id }}
      </template>
      <template #cell(description)="data" class="f-default">
        <slot name="description" v-bind="{ data }" />
      </template>
      <template #cell(createdAt)="data" class="f-default">
        <slot name="createdAt" v-bind="{ data }" />
      </template>
      <template #cell(company)="data" class="f-default">
        <slot name="company" v-bind="{ data }" />
      </template>
      <template #cell(online)="data" class="f-default">
        <slot name="online" v-bind="{ data }" />
      </template>
      <template #cell(domainsuspect)="data" class="f-default">
        <slot name="domainsuspect" v-bind="{ data }" />
      </template>
      <template #cell(urlMatch)="data" class="f-default">
        <slot name="urlMatch" v-bind="{ data }" />
      </template>
      <template #cell(urlReference)="data" class="f-default">
        <slot name="urlReference" v-bind="{ data }" />
      </template>
      <template #cell(severity)="data" class="f-default">
        <slot name="severity" v-bind="{ data }" />
      </template>
        <template #cell(criticality)="data" class="f-default">
        <slot name="criticality" v-bind="{ data }" />
      </template>
      <template #cell(payload)="data">
        <slot name="payload" v-bind="{ data }" />
      </template>
      <template #cell(isActive)="data" class="f-default">
        <slot name="isActive" v-bind="{ data }" />
      </template>
      <template #cell(accessToken)="data" class="f-default">
        <slot name="accessToken" v-bind="{ data }" />
      </template>
      <template #cell(statusInternal)="data" class="f-default">
        <slot name="statusInternal" v-bind="{ data }" />
      </template>
      <template #cell(status)="data" class="f-default">
        <slot name="status" v-bind="{ data }" />
      </template>

      <template #cell(actions)="data" class="f-default">
        <slot name="actions" v-bind="{ data }" />
      </template>
    </b-table>
    <b-row  v-if="isDefault">
      <b-col cols="12" class="d-flex justify-content-end">
        <select
          class="custom-select form-control"
          v-model="filters.size"
          style="width: 93px"
        >
          <option :value="op" v-for="op in options" :key="op">{{ op }}</option>
        </select>
        <span class="mr-4 itens">Itens</span>
        <b-pagination
          v-model="filters.page"
          :total-rows="dataArray.totalElements"
          :per-page="filters.size"
          prev-text="Anterior"
          next-text="Próximo"
          aria-controls="my-table"
          :last-number="true"
          :first-number="true"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      default: () => ({
        size: 10,
        findBy: '',
        page: 1
      })
    },
    dataArray: {
      type: [ Object, Array ],
      required: true
    },
    fields: {
      type: Array,
    },
    title: {
      type: String,
    },
    isRoute:{
      type:Boolean,
      default: false
    },
    isDefault:{
      type:Boolean,
      default:true
    },
    route:{
      type: Object,
    }
  },
  computed: {
    observerFilters () {
      return Object.assign({}, this.filters)
    },
    items () {
      return this.isDefault ? this.dataArray.content : this.dataArray
    }
  },
  watch: {
    observerFilters: {
      deep: true,
      handler (newValue, oldValue) {
        if (newValue.page !== oldValue.page) {
          this.$emit('currentPage', newValue.page - 1)
        }
        if (newValue.size !== oldValue.size) {
          this.$emit('perPage', newValue.size)
        }
      }
    }
  },
  methods: {
    getCustomClass (field) {
      if (field.customClass) return field.customClass(field)
      return undefined
    },
    sendSearch () {
      this.$emit('search-fn')
      this.$emit('keyword', this.filters.findBy)
    }
  },
  data() {
    return {
      options: [10, 25, 50, 100],
    };
  }
};
</script>

<style scoped lang="scss">
.table-component {
  .search {
    display: flex;
    position: relative;
    height: 40px;
    input {
      height: 100%;
    }
    button {
      display: grid;
      place-items: center;
      height: 100%;
      padding: 0;
      width: 40px;
      background: #F5F5F6;
      border: none;
      &:active {
        background-color: #dadada;
      }
    }
  }
}
::v-deep table {
  td {
    vertical-align: middle;
  }
  thead tr {
    > :nth-child(n) {
      background-image: none!important;
      padding: .75rem!important;
      &[aria-sort=none] > span {
        background-image: url('/images/components/mitre/table_sort_none.svg');
      }
      &[aria-sort=descending] > span {
        background-image: url('/images/components/mitre/table_sort_desc.svg');
      }
      &[aria-sort=ascending] > span {
        background-image: url('/images/components/mitre/table_sort_asc.svg');
      }
      span {
        margin-right: -2rem;
        padding-right: 1rem;
        background-size: 8px 16px;
        background-repeat: no-repeat;
        background-position: right center;
      }
    }
  }
  th {
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0em;
    font-family: Poppins;

    text-align: left;
  }
  td {
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }
  // tr {
  //   td:nth-child(1) {
  //     background-color: #d6d9da33;
  //   }
  // }
  .badge {
    width: 100px;
  }
}
.title {
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .pagination {
  .page-item {
    &.active {
      button {
        background-color: #040a10 !important;
        border: 1px solid #040a10 !important;
        box-shadow: none !important;
        &:hover {
          background-color: #040a10 !important;
        }
      }
    }
    button {
      color: #6c757d;
      &:hover {
        background-color: transparent !important;
      }
    }
  }
}
.itens {
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #6c757d;
  margin-top: 5px;
  margin-left: 10px;
}

.export {
  img {
    height: 30px;
    cursor: pointer;
  }
}

.img-search{
  height: 40px;
}
</style>
